import { TList } from "@/shared/model/types"

export const transform = (arr: TList, lang: string) => {
	return Object.entries(arr).map(([key, item]) => ({
		name: item.title[lang],
		on_market: item.on_market,
		type: key
	}))
}
